






















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, PropSync, Watch } from 'vue-property-decorator';
import AttachmentZone from '@/modules/tickets/incidents/shared/components/AttachementZone.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import {
    ALLOWED_EXTENSIONS,
    isValidFile,
} from '@/modules/shared/shared/domain/functions/allowed-files';

@Component({
    name: 'attachment-selection',
    components: { BaseModal, AttachmentZone },
})
export default class AttachmentSelection extends Vue {
    private text: string = '';
    private rules: any = rules;
    private wasOpen: boolean = false;
    private fieldRestore: number = 0;

    private readonly validExtensions = ALLOWED_EXTENSIONS;

    get availableFiles() {
        return [...this.validExtensions].join(',');
    }

    $refs!: {
        file: any;
        modal: any;
        form: any;
    };

    @PropSync('selectedFile', { required: true })
    file!: File;

    tempFile: File | null = null;

    public validate() {
        this.$refs.file.validate();
    }

    get validFile() {
        if (this.tempFile) {
            return isValidFile(this.tempFile);
        }
        return true;
    }

    @Watch('file')
    onFileChanged(file) {
        if (file) {
            const { name = '', size = 0 } = file;

            const truncatedText = this.truncateText(name);

            this.text = `${truncatedText} (${this.humanReadableFileSize(size, false)})`;
        } else {
            this.text = '';
        }
    }

    humanReadableFileSize(bytes: number, binary = false): string {
        const base = binary ? 1024 : 1000;
        if (bytes < base) {
            return `${bytes} B`;
        }

        const prefix = binary ? ['Ki', 'Mi', 'Gi'] : ['k', 'M', 'G'];
        let unit = -1;
        while (Math.abs(bytes) >= base && unit < prefix.length - 1) {
            bytes /= base;
            ++unit;
        }
        return `${bytes.toFixed(1)} ${prefix[unit]}B`;
    }

    truncateText(str: string) {
        if (str.length < 22) return str;
        const charsKeepOneSide = Math.floor((Number(22) - 1) / 2);
        return `${str.slice(0, charsKeepOneSide)}…${str.slice(str.length - charsKeepOneSide)}`;
    }

    get dragActive() {
        return this.wasOpen && this.$refs.modal.isOpened;
    }
}
